import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.video-consultation': {
         approveAndEndVideoConsultation: 'Zatwierdź i zakończ wideokonsultację',

         callWith: 'Rozmowa z {{participantName}}',
         failedToFetchVideoConsultationData:
            'Nie udało się pobrać informacji o wideokonsultacji. Poczekaj i spróbuj ponownie.',
         fillInPatientContactData: 'Uzupełnij dane kontaktowe pacjenta',
         pending: 'W toku...',
         restoreWindow: 'Przywróć okno',
         saveData: 'Zapisz dane',
         videoConsultationInProgress: 'Wideokonsultacja w toku',
         youAreNowHavingConversationWithParticipantEndConversationAndTryAgain:
            'Prowadzisz teraz rozmowę z {{participantName}}. Zakończ rozmowę i spróbuj ponownie.',
         youCannotStartVideoConsultationYouHaveOngoingVideoConsultation:
            'Nie można rozpocząć wideokonsultacji. Posiadasz trwającą wideokonsultację na innej wizycie.',
         youHaveOngoingVideoCall: 'Posiadasz trwającą wideokonsultację',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.video-consultation');
